// === Click2Gro Web — Entry Point ===

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';

// Auto-reload when a lazy-loaded chunk 404s after a new deploy.
// Vite hashes chunk filenames — old hashes become invalid after deployment.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found — check index.html has <div id="root">');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
